<div class="content-editor-container">
    <div #editorContainer class="editor-container">
        <div
            [froalaEditor]="froalaOptions"
            [formControl]="froalaContentFormControl()"
            [attr.data-role]="'drag-drop-target'"></div>
        @if (showErrors() && froalaContentFormControl().invalid && froalaContentFormControl().touched) {
            @if (froalaContentFormControl().errors?.['required']) {
                <mat-error>This field is required.</mat-error>
            }
        }
        <div class="hidden-editor"></div>
    </div>

    <div class="content-list-container">
        <h3>Field Merges</h3>

        <mat-form-field class="content-source-container">
            <mat-label>Source</mat-label>
            <input
                type="text"
                matInput
                [formControl]="sourceFormControl"
                [matAutocomplete]="auto"
                (keydown.enter)="doNotPropogateEnter($event)" />
            <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onSourceSelected($event)"
                [displayWith]="displayFn">
                @for (option of sourceOptions(); track $index) {
                    <mat-option [value]="option" [disabled]="option.disabled">{{ option.displayName }}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="filter-container">
            <mat-label>Filter</mat-label>
            <input
                #searchInput
                matInput
                type="text"
                placeholder="Type to Filter"
                [formControl]="searchFormControl"
                (keydown.enter)="doNotPropogateEnter($event)" />
        </mat-form-field>

        <div class="field-merge-container" (scroll)="onFieldMergeContainerScroll($event)">
            @for (fieldMergeOption of fieldMergeOptions(); track $index) {
                @if (fieldMergeOption.sourceName && fieldMergeOptions().length > 0) {
                    <span class="search-option-souce-name">{{ fieldMergeOption.sourceName }}</span>
                }
                @for (mergeField of fieldMergeOption.mergeFieldData; track $index) {
                    @if (mergeField.fieldType === 'customHTML') {
                        <div
                            r1Draggable
                            [contentEditable]="false"
                            [id]="mergeField.id"
                            [class]="mergeField.class"
                            [attr.data-content-type]="mergeField.dataContentType"
                            [attr.data-content-options]="mergeField.dataContentOptions">
                            {{ mergeField.displayName }}
                        </div>
                    } @else {
                        <span
                            r1Draggable
                            [contentEditable]="false"
                            [id]="mergeField.id"
                            [class]="mergeField.class"
                            [attr.data-content-type]="mergeField.dataContentType"
                            [attr.data-content-options]="mergeField.dataContentOptions"
                            >{{ mergeField.displayName }}</span
                        >
                    }
                }
            }
        </div>
    </div>
</div>
